/*
 * @Author: ext.shuiqianning1
 * @Date: 2022-06-28 15:21:10
 * @LastEditors: ext.shuiqianning1
 * @LastEditTime: 2022-08-15 20:30:29
 * @FilePath: /dpInquery/src/utils/seoFooter.js
 */
export const seoFooter = () => {
  const rnDoctorListDom = document.querySelector("#m_common_bottom");
  if (rnDoctorListDom) {
    rnDoctorListDom.innerHTML = `  <div style='margin-top:10px;'>
    <a
      href="https://www.jdh.com/sitemap.html"
      data-a-href="https://www.jdh.com/sitemap.html"
      rel="nofollow"
      data-a-nofollow="true"
      style='
      font-size:14px;
      font-family: PingFang SC;
      font-weight: normal;
      color: rgba(100, 101, 102, 1);
      margin-right: 10px;'
    >
      网站地图
    </a>
  </div><h2 class='footerDataInvestor' style='margin-top:4px;'>
          <a href="https://m.360buyimg.com/babel/jfs/t1/181014/6/22558/388522/62568785E608ef36a/d9ccabbcd5f95057.png!q20.webp"
          data-a-href="https://m.360buyimg.com/babel/jfs/t1/181014/6/22558/388522/62568785E608ef36a/d9ccabbcd5f95057.png!q20.webp"
          style='
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: normal;
          color: rgba(100, 101, 102, 1);
          margin-right: 10px;'
          data-a-nofollow="true"
          >
            营业执照
          </a>
          <a 
          style='
          font-size:14px;
          font-family: PingFang SC;
          font-weight: normal;
          color: rgba(100, 101, 102, 1);
          '
          data-a-nofollow="true"
          data-a-href="https://ir.jdhealth.com/sc/index.php"
          href="https://ir.jdhealth.com/sc/index.php"> Investor Relations</a>
        </h2>
        <p 
        style='font-size: 14px;
        font-family: PingFang SC;
        font-weight: normal;
        color: rgba(100, 101, 102, 1);
        margin-top: 6px;'
        >违法和不良信息举报电话：4006561155 消费者维权热线：4006067733</p>
        <p 
        style='font-size: 14px;
        font-family: PingFang SC;
        font-weight: normal;
        color: rgba(100, 101, 102, 1);
        margin-top: 6px;'
        >Copyright © 2022 jdh.com 版权所有</p>
        <h2 class='footerDataImg' style='display: flex;align-items: center;margin-top: 6px;'>
          <img src='https://img14.360buyimg.com/imagetools/jfs/t1/114538/24/27830/3963/62bab5adE0f9367a6/15d568d66ee31c84.png'
          style='width: 20px;
          height: 20px;
          margin-right: 6px;'
          alt="" />
          <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=45050202000590"
          data-a-nofollow="true"  
          data-a-href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=45050202000590"
          style='
          font-size:14px;
          font-family: PingFang SC;
          font-weight: normal;
          color: rgba(100, 101, 102, 1);
          margin-right: 10px;'>
            桂公网安备 45050202000590号
          </a>
          <a style='
          font-size:14px;
          font-family: PingFang SC;
          font-weight: normal;
          color: rgba(100, 101, 102, 1);
          ' 
          data-a-nofollow="true"
          data-a-href="https://beian.miit.gov.cn/"
          href="https://beian.miit.gov.cn/">桂ICP备2022000128-5</a>
        </h2>`;
  }
};
